import { useContext } from 'react'
import { FeatureToggleContext } from 'context'
import { IFeature } from 'interfaces'

export const useFeatureToggle = (featureKey?: string): boolean | IFeature[] => {
  const { features } = useContext(FeatureToggleContext)

  if (!featureKey) return features || []

  // Defensive check: ensure features array exists before calling find
  if (!features || !Array.isArray(features)) {
    return false
  }

  const featureFlag = features.find(feature => feature.key === featureKey && feature.state === 'on')

  return featureFlag ? true : false
}

export const useFeatureToggleLoading = (): boolean => {
  const { isLoading } = useContext(FeatureToggleContext)
  return isLoading
}